import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '@/services/authConfig';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

export function useRole() {
  const { instance, accounts } = useMsal();
  const [permissions, setPermissions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Dev override
    if (import.meta.env.DEV) {
      setPermissions(['p:vi.inspector', 'p:vi.supervisor', 'p:vi.admin']);
      setLoading(false);
      return;
    }

    if (accounts.length === 0) {
      setLoading(false);
      return;
    }

    async function loadPermissions() {
      try {
        let tokenResponse;
        try {
          tokenResponse = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });
          console.log('Token acquired successfully');
        } catch (tokenErr) {
          console.error('Token acquisition failed:', tokenErr);
          if (tokenErr instanceof InteractionRequiredAuthError) {
            tokenResponse = await instance.acquireTokenPopup({
              ...loginRequest,
              account: accounts[0],
            });
          } else {
            setPermissions(['p:vi.inspector']);
            setLoading(false);
            return;
          }
        }

        const r = await fetch('/api/me/permissions', {
          headers: {
            Authorization: `Bearer ${tokenResponse.accessToken}`,
          },
        });

        if (!r.ok) {
          console.error('Permissions API returned:', r.status);
          setPermissions(['p:vi.inspector']);
          setLoading(false);
          return;
        }

        const data = await r.json();
        console.log('Permissions response:', data);
        setPermissions(Array.isArray(data.permissions) ? data.permissions : ['p:vi.inspector']);
        setLoading(false);

      } catch (err) {
        console.error('Failed to fetch permissions:', err);
        setPermissions(['p:vi.inspector']);
        setLoading(false);
      }
    }

    loadPermissions();
  }, [accounts[0]?.localAccountId]);

  const isAdmin = permissions.includes('p:vi.admin');
  const isSupervisor = permissions.includes('p:vi.supervisor');

  return {
    permissions,
    loading,
    isInspector: permissions.includes('p:vi.inspector'),
    isSupervisor,
    isAdmin,
    canApprove: isSupervisor || isAdmin,
    canViewDashboard: isSupervisor || isAdmin,
    canManageUsers: isAdmin,
  };
}